var swiperCollection = new Swiper(".swiper.is-collection", {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 2
    },
    992: {
      slidesPerView: 4,
      spaceBetween: 20,
    }
  }
});

function initializeVariantThumbnails() {
  const uniqueColors = new Set(Array.from(document.querySelectorAll(".pdp-thumb-swiper .swiper-slide")).map(thumb => thumb.getAttribute("thumbnail-alt")).filter(Boolean));
  document.querySelectorAll(".pdp-thumb-swiper .swiper-slide").forEach(thumb => {
      thumb.classList.remove("swiper-slide-thumb-active")
  }),
  uniqueColors.forEach(color => {
      const colorThumbs = Array.from(document.querySelectorAll(`.pdp-thumb-swiper .swiper-slide[thumbnail-alt="${color}"]`));
      colorThumbs.length > 0 && colorThumbs[0].classList.add("swiper-slide-thumb-active")
  })
}

var swiperPDP = new Swiper(".swiper.pdp-swiper", {
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  on: {
      init: function() {
          initializeVariantThumbnails(),
          this.update()
      }
  }
});

  var acc = document.getElementsByClassName("accordion");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      /* Toggle between adding and removing the "active" class,
      to highlight the button that controls the panel */
      this.classList.toggle("active");
      /* Toggle between hiding and showing the active panel */
      var panel = this.nextElementSibling;
      panel.classList.toggle("active");
    });
  }

$.fancybox.defaults.animationEffect = "fade";
$('[data-fancybox]').fancybox({
  buttons: [
    "close"
  ],
});
